module.exports = __webpack_public_path__ + "img/coin-200x.8242e8a2.svg";